import { NavigationNodeId } from '@pwc/pwc-deals-web-common';
import { useTranslation } from 'react-i18next';

export const useKFATitleI18n = (KFATitle: string) => {
  const { t } = useTranslation();
  const KFATitleI18n =
    KFATitle === NavigationNodeId.KEY_FOCUS_AREAS
      ? t('keyFocusArea')
      : KFATitle;
  return KFATitleI18n;
};
